<template lang="pug">
  div.qmod-modal-wrap(v-if="getModalIsOpen")
    div.qmod-modal-cont(v-if="getModalIsOpen")
      div.qmod-modal-header
        span.qmod-modal-title {{getModalTitle}}
        span.qmod-modal-hbtns
          span.qmod-modal-btn.qmod-close-btn(v-on:click="closeModal"): i.material-icons.md-18 close
      div.qmod-modal-body
        slot(name='modalContent')

</template>

<script>
import { mapGetters } from "vuex"
//
export default {
  name: "ModalWrapper",
  props: ["enabled"],
  data() {
    return {
      // isEnabled: this.enabled,
    }
  },
  methods: {
    closeModal() {
      this.$store.commit("AdvancedChart/SET_MODAL_ISOPEN", false)
    }
  },
  computed: {
    ...mapGetters("AdvancedChart", ["getModalIsOpen", "getModalTitle"])
  },
  mounted() {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
$qmblue = #2196f3
.qmod-modal-wrap
  background rgba(0, 0, 0, 0.3)
  z-index 9998
  position fixed
  right 0
  left 0
  top 0
  bottom 0
  .qmod-modal-btn
    display inline-flex
    cursor pointer
    border-radius 50%
    padding 8px
    transition background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
    &.qmod-close-btn:hover
      background-color rgba(255, 255, 255, 0.1)
  .qmod-modal-cont
    box-shadow 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)
    display flex
    flex-direction column
    background-color #fff
    color #000
    min-width 280px
    min-height 300px
    max-height 95%
    position fixed
    top 50%
    left 50%
    border 1px solid $qmblue
    border-radius 2px
    transform translate(-50%, -50%)
    .qmod-modal-header
      font-size 20px
      min-height 48px
      align-content center
      align-items center
      display flex
      color #fff
      background-color $qmblue
      .qmod-modal-hbtns
        padding-right 5px
        display flex
        margin-left auto
      .qmod-modal-title
        display inline-block
        padding 8px 12px
    .qmod-modal-body
      margin auto 0
      flex 1
      flex-direction column
      padding 8px 12px
      display flex
      .qmod-modal-content
        margin-bottom 5px
      .qmod-modal-confirm
        margin-top auto
        text-align center
</style>
